export default "__VITE_ASSET__8f5fb989__"